// extracted by mini-css-extract-plugin
module.exports = {"cardsContainer":"az_xr","skinnyRecommendations":"az_yr"};